import Notification from '@serko/zui/es/Notification';
import NotificationContentText from '@serko/zui/es/NotificationContentText';
import React, { FunctionComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import messages from '../../intl/messages';
import Typography from '@material-ui/core/Typography';

interface OwnProps {
  isSaviSelectIntl: boolean;
}

interface ChangesRequestedProps extends OwnProps, InjectedIntlProps {}

const ChangesRequestedBase: FunctionComponent<ChangesRequestedProps> = ({
  intl: { formatMessage },
  isSaviSelectIntl,
}) => (
  <Notification type="Warning">
    <NotificationContentText>
      <Typography variant="subheading">
        {formatMessage(messages.notification.trip.changesRequested)}
      </Typography>
      {isSaviSelectIntl && (
        <Typography variant="body1">
          {formatMessage(messages.notification.trip.disclaimer)}
        </Typography>
      )}
    </NotificationContentText>
  </Notification>
);

export const ChangesRequested = injectIntl(ChangesRequestedBase);

ChangesRequested.displayName = 'ChangesRequested';
